<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.date')">
                    <el-date-picker v-model="formInline.data" value-format="yyyy-MM" type="monthrange" range-separator="至"
                      start-placeholder="开始月份" end-placeholder="结束月份">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('common.orgName')">
                    <el-select v-model="formInline.orgId" :placeholder="$t('common.form.choseTip')" filterable
                      size="mini" style="width: 150px">
                      <el-option v-for="item in orgIdList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t('common.btn.search') }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{ $t('common.btn.cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('REPORTANALYSIS_VEHICLEOPERATIONSUMMARYTABLE_DOWN')" type="text"
                  @click="downCar">{{ $t('common.btn.download') }}</el-button>
              </div>
              <div class="rightAll-table">
                <el-table v-loading="loading" ref="dataTable" :height="tableHeight" border stripe :span-method="arraySpanMethod" :data="list" :cell-class-name="setClass"
                  style="width: 100%">
                  <el-table-column type="index" :label="$t('common.id')" width="50" align="center">
                  </el-table-column>
                  <el-table-column prop="orgName" :label="$t('common.orgName')" align="center">
                  </el-table-column>
                  <el-table-column label="月份" width="120" align="center">
                    <el-table-column prop="description" label="额定载荷" width="100" align="center">
                    </el-table-column>
                  </el-table-column>
                  <template v-for="item in columnList">
                    <el-table-column :prop="item.prop" :label="item.label" align="center">
                      <!-- <el-table-column :prop="item.prop + '.capacityCount1'" label="1.5t" width="60" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.capacityCount2'" label="2t" width="60" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.capacityCount3'" label="2.5t" width="60" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.capacityCount4'" label="其他" width="60" align="center">
                      </el-table-column> -->
                      <el-table-column :prop="item.prop + '.carCount'" label="租赁车辆总数" width="110" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.workTimeCount'" label="总运行时间" width="100" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.workTimeAvg'" label="台均运行时间" width="110" align="center">
                      </el-table-column>
                    </el-table-column>
                  </template>
                </el-table>
              </div>
              <!-- <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table> -->
              <!-- <IPagination ref="page" @PageFun="changeSize"></IPagination> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VehicleOperationSummaryTable from "./VehicleOperationSummaryTable";
export default VehicleOperationSummaryTable;
</script>

<style lang="less" scoped>
::v-deep .el-table__row {
  .addBorder {
    background-color: #2a548e !important;
  }
}
.rightAll-table ::v-deep .el-table th {
    height: 24px !important;
}

@import "../../../assets/styles/Style.less";
</style>
